(() => {
  if (window.dfProductInformationInstalled) return;
  window.dfProductInformationInstalled = true;
  const productSelector = 'product-info[data-df-product-information-enabled]';
  const disclosureAnimations = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const toggleDisclosure = (details) => {
    const summary = details.querySelector(':scope > summary');
    const running = disclosureAnimations.get(details);
    const expanding = running ? !running.expanding : !details.open;
    const from = details.getBoundingClientRect().height;
    if (running) running.animation.cancel();
    details.style.height = '';
    details.open = true;
    const to = expanding ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height + 1;
    summary.setAttribute('aria-expanded', String(expanding));
    const finish = () => {
      details.open = expanding;
      details.style.height = '';
      delete details.dataset.dfAnimating;
      disclosureAnimations.delete(details);
    };
    if (reducedMotion.matches || !details.animate) { finish(); return; }
    details.dataset.dfAnimating = 'true';
    const animation = details.animate([{height: from + 'px'}, {height: to + 'px'}], {duration:220, easing:'ease-out'});
    disclosureAnimations.set(details, {animation, expanding});
    animation.onfinish = finish;
  };

  const profileFor = (value) => {
    const name = (value || '').toLowerCase();
    if (name.includes('comfort colors')) return 'comfort';
    if (name.includes('made in usa')) return 'usa';
    if (name.includes('made in italy')) return 'italy';
    if (name.includes('value')) return 'value';
    return null;
  };
  const sync = (root) => {
    const select = root.querySelector('select[name="options[Available Products]"]');
    const profile = profileFor(select?.value);
    root.querySelectorAll('[data-df-size-profile]').forEach((panel) => {
      panel.hidden = panel.dataset.dfSizeProfile !== profile;
    });
    const guide = root.querySelector('.df-size-guide');
    if (guide) guide.hidden = !profile;
  };
  const init = () => document.querySelectorAll(productSelector).forEach((root) => {
    if (root.dataset.dfInformationBound) return;
    root.dataset.dfInformationBound = 'true';
    sync(root);
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; sync(root); });
    }).observe(root, { childList: true, subtree: true });
    root.addEventListener('change', () => requestAnimationFrame(() => sync(root)));
  });
  document.addEventListener('click', (event) => {

    const summary = event.target.closest('.df-product-information .df-info-disclosure > summary');
    if (summary && summary.closest(productSelector)) {
      event.preventDefault();
      toggleDisclosure(summary.parentElement);
      return;
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
